"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class SettingsHelper {
    static getSettings(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            let request = new Request(baseRoute + '/service/settings', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            var response = yield fetch(request);
            return response
                .json()
                .catch(() => {
                throw 'Error getting JSON for settings.';
            })
                .then(json => {
                if (!response.ok || !json.Success) {
                    throw 'Error settings.';
                }
                return json.Data;
            });
        });
    }
    static getAuthenticationUrl(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            let settings = yield SettingsHelper.getSettings(baseRoute);
            return Promise.resolve(settings['AuthenticationServiceBaseUrl']);
        });
    }
    static getApplicationSettings(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            let settings = yield SettingsHelper.getSettings(baseRoute);
            return Promise.resolve(settings);
        });
    }
    static getMsalAuthSettings(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            let request = new Request(baseRoute + '/service/msal', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            var response = yield fetch(request);
            return response
                .json()
                .catch((err) => {
                throw 'Error getting JSON for MSAL auth settings.';
            })
                .then(json => {
                if (!response.ok || !json.Success) {
                    throw 'Error getting MSAL auth settings.';
                }
                return json.Data;
            });
        });
    }
    static getUMV2AuthSettings(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            let request = new Request(baseRoute + '/service/UMV2', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            var response = yield fetch(request);
            return response
                .json()
                .catch(() => {
                throw 'Error getting JSON for UMV2 auth settings.';
            })
                .then(json => {
                if (!response.ok || !json.Success) {
                    throw 'Error getting UMV2 auth settings.';
                }
                return json.Data;
            });
        });
    }
}
exports.SettingsHelper = SettingsHelper;
//# sourceMappingURL=SettingsHelper.js.map